import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/vacancy/searchVacancy', { params: request })
  },
  find: function (id) {
    return axios.get('/api/vacancy/findVacancy?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveVacancy', data)
  },  
  delete: function (id) {
    return axios.get('/api/vacancy/deleteVacancy?id=' + id)
  },
  import: function() {
    return axios.get('/api/vacancy/import')
  }
}